export class Utilities {
  static GetZohoDate(date) {
    return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
  }
  static UnmaskPhone(masked) {
    return masked.slice(4, 7) + masked.slice(9, 12) + masked.slice(13, 17);
  }
}